import {Endpoint} from '../../base';
import {ITenantResponse} from './models/';

export const getTenant = () => Endpoint
    .get<ITenantResponse>('tenants')
    .then((r) => r.data);